import "./SeriesPage.scss";

import SeriesPage from "./SeriesPage";

export default SeriesPage;
